import React from 'react';

import { Instructions, SanitizedHtml } from '.';
import { withInteractiveStore } from './TemplateWithInteractiveStore';

const titleSizeClass = (size) => {
  if (size === 'lg') {
    return ''
  } 
  return `dinfos-slider--title-${size}`
}

const SliderWithoutStore = React.memo(({interactive, assets, ...props}) => {

  const {bg,id,displayTitle,theme,tiles,tileType,tileHeadingSize,tileHeadingStyle} = interactive;
  const showInstructions = props.forwardedRef ? true : false;

  if (!theme || !displayTitle) {
    return '';
  }

  const massagedTitle = displayTitle.replace(/<strong>/g, '<strong class="dinfos-slider__title--emphasis">')

  return (
    <div id="interactive-template" ref={props.forwardedRef}>
      <div className="dinfos-intv__wrapper"> 

        <section className={`dinfos-slider dinfos-slider--${theme} ${titleSizeClass(tileHeadingSize)} ${showInstructions ? 'overflow-hidden' : ''}`} style={bg && bg.src ? {backgroundImage:`url(${assets[bg.src]}`} : {}} data-src={bg && bg.src ? bg.src : null} id={id} data-intv>

          <Instructions hide={!showInstructions} instructions="Discover content by selecting individual tiles, or using the buttons across the top." id={`${id}-instr`} />
          
          <h2 className="dinfos-slider__title"><SanitizedHtml content={massagedTitle}/></h2>
          
          <div className="dinfos-slider__nodes dinfos-drag-scroll-x">
            {tiles ? tiles.map((tile, index) => (
              <a className="dinfos-slider__node" href={`#${id}-tile-${index}`} key={index}>
                <span className="dinfos-slider__node-line"></span>
                <span className="dinfos-slider__node-circle"></span>
                <span className="dinfos-slider__node-text">{tile.node}</span>
              </a>
            )) : ''}
          </div>
            
          <div className="dinfos-slider__track dinfos-drag-scroll-x">
            {tiles ? tiles.map((tile, index) => (
              <React.Fragment key={index}>
                <button 
                  type="button" 
                  className={`dinfos-slider__tile${tileType === 'word' ? ' dinfos-slider__tile--small-text' : (tileType === 'icon' ? ' dinfos-slider__tile--icon' : '')}`} 
                  aria-expanded="false" 
                  key={index}
                  id={`${id}-tile-${index}`}
                  style={tile.bg && tile.bg.src ? {backgroundImage:`url(${assets[tile.bg.src]})`} : null } 
                  data-src={tile.bg && tile.bg.src ? tile.bg.src : null }
                  aria-label={tileType === 'icon' ? tile.node : false}                    
                >
                  <span>
                  { tileType === 'icon' ? 
                    <i className={`fa${tile.iconSet ? tile.iconSet : 's'} fa-${tile.label}`}></i>
                  :
                    tile.label
                  }
                  </span>
                </button>
                { tile.title ? 
                  <div className="dinfos-slider__panel" aria-controls={`${id}-tile-${index}`}>
                    <button type="button" className="dinfos-slider__panel-close" aria-label="Close Panel"><i className="fas fa-times" aria-hidden="true"></i></button>
                    <div className="dinfos-slider__panel-scroll">
                      <h3 className={`dinfos-slider__panel-title${ tileHeadingStyle.indexOf('dots') >= 0 ? ' dinfos-slider__panel-title--dots' : ''} ${tileHeadingStyle.indexOf('accent') >= 0 ? ' dinfos-slider__panel-title--accent' : '' }`}>
                        { 
                          tileHeadingStyle.indexOf('pretitle') >= 0 && tile.pretitle ? 
                          <span className="dinfos-slider__panel-supertitle">{tile.pretitle}</span>
                          : ''
                        }
                        {tile.title}
                      </h3>
                      <div className="dinfos-slider__panel-body">
                          <SanitizedHtml content={tile.body} />
                      </div>
                    </div>
                  </div>
                : '' }
              </React.Fragment>
            )) : ''}
          </div>
          
        </section>
      </div>
    </div>
  )

})

export const Slider = withInteractiveStore(
  SliderWithoutStore,
);